export default (keys: any[], hash: any) =>
  keys.reduce(
    (newHash, key) => (newHash && newHash[key] ? newHash[key] : null),
    hash,
  );
